function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import propTypes from '@styled-system/prop-types';
import cloudinary from 'cloudinary-core';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { border } from 'styled-system';
import Box from './Box';
const cl = new cloudinary.Cloudinary({
  cloud_name: 'paperstac',
  secure: true
});
const CLOUDINARY_PREFIX = 'https://res.cloudinary.com/paperstac/image/upload/';
const StyledImage = styled(Box).withConfig({
  displayName: "Image__StyledImage",
  componentId: "sc-p1zff6-0"
})(border);
const Image = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    crop = true,
    src,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledImage, _extends({
    ref: ref,
    as: "img",
    src: transformSrc(src, {
      crop,
      ...props
    }),
    crop: crop
  }, props, {
    __css: {
      maxWidth: '100%',
      height: 'auto',
      borders: 'none'
    }
  }));
});
Image.propTypes = {
  ...Box.propTypes,
  ...propTypes.border,
  crop: PropTypes.bool,
  size: PropTypes.number
};
Image.displayName = 'Image';
export default Image;
const transformSrc = (src, props) => {
  if (src.startsWith(CLOUDINARY_PREFIX) && typeof window === 'object') {
    const config = {
      fetchFormat: 'auto',
      quality: 'auto',
      dpr: window && window.devicePixelRatio ? window.devicePixelRatio : 'auto',
      crop: props.crop ? 'fill' : 'fit'
    };
    if (props.width || props.size) {
      config.width = Array.isArray(props.width) ? props.width[props.width.length - 1] : props.width || props.size;
    }
    if (props.height || props.size) {
      config.height = Array.isArray(props.height) ? props.height[props.height.length - 1] : props.height || props.size;
    }
    return cl.url(src.replace(CLOUDINARY_PREFIX, ''), config);
  }
  return src;
};